import ActionBtn from '@/components/ActionBtn'
import Popup from '@/components/popup'
import "./style.css"
import { useTranslation } from 'react-i18next'

const BrokerMissingPopup = ({title, name, modalID, patient, refUploadPatientMedicalFilesModal, addPatientModalRef,setSelectedPatient}) => {
    const {t}= useTranslation()
    const viewMissingData = () =>{
        modalID?.current?.click()
        setSelectedPatient(patient)
        addPatientModalRef?.current?.click()
    }
    const uploadMedicalFiles = () =>{
        modalID?.current?.click()
        refUploadPatientMedicalFilesModal?.current?.click()
    }


  return (
    <Popup needbtn={false} large={false} title={title} name={name} modalID={modalID}>
        <div className='missing-data-popup-wrapper'>
        <p className='missing-data-msg'>
            {patient?.missingDataMsg}
        </p>
        <div className='missing-data-btns'>
            <ActionBtn title={t("upload-files")}  onApply={uploadMedicalFiles} icon="solar:upload-outline" className="missing-files-btn" />
            <ActionBtn title={t("fill-missing-data")}  onApply={viewMissingData} icon="sidekickicons:checklist-boxes" className="missing-data-btn" />
        </div>
    </div>
    </Popup>
  )
}

export default BrokerMissingPopup



